import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { PiiCategory, meta } from "../meta.mjs";
import { intervalsOverlap } from "./clinicalReservations.mjs";
import { z as z$1 } from "zod";

// src/models/consultation/clinicalCustomerDraftSelects.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date());
/** Sibling of clinical availability slots — clinical draft-select namespace only. */
const CLINICAL_CUSTOMER_DRAFT_SELECTS_DOC_ID = "clinical_customer_draft_selects";
/** Server and client TTL for stale draft picks (matches coach flow). */
const CLINICAL_CUSTOMER_DRAFT_SELECT_MAX_AGE_MS = 6e5;
const clinicalCustomerDraftEntrySchema = z$1.object({
	selectedAt: firestoreDate,
	startTimeInMS: z$1.number().int().nonnegative(),
	endTimeInMS: z$1.number().int().positive(),
	tellescopeUserId: meta(z$1.string().min(1), { pii: { category: "identifier" } })
});
const clinicalCustomerDraftSelectsSchema = z$1.object({
	customerDrafts: z$1.record(z$1.string(), clinicalCustomerDraftEntrySchema),
	createdAt: firestoreDate
});
function draftSelectInterval(entry) {
	return {
		start: entry.startTimeInMS,
		end: entry.endTimeInMS
	};
}
function slotInterval(args) {
	return {
		start: args.startTimeInMS,
		end: args.startTimeInMS + args.durationInMinutes * 6e4
	};
}
/**
* Returns true if an active (non-stale) draft for the same NP overlaps the
* candidate slot interval. Optionally ignore a customer's own draft pick.
*/
function hasOverlappingClinicalDraftSelect(args) {
	const now = args.now ?? /* @__PURE__ */ new Date();
	const maxAgeMs = args.maxAgeMs ?? 6e5;
	const cutoff = now.getTime() - maxAgeMs;
	const candidate = slotInterval(args);
	if (!args.customerDrafts) return false;
	for (const [customerId, entry] of Object.entries(args.customerDrafts)) {
		if (args.ignoreCustomerId && customerId === args.ignoreCustomerId) continue;
		if (entry.tellescopeUserId !== args.tellescopeUserId) continue;
		if (entry.selectedAt.getTime() < cutoff) continue;
		const draft = draftSelectInterval(entry);
		if (intervalsOverlap(candidate, draft)) return true;
	}
	return false;
}

export { CLINICAL_CUSTOMER_DRAFT_SELECTS_DOC_ID, CLINICAL_CUSTOMER_DRAFT_SELECT_MAX_AGE_MS, clinicalCustomerDraftEntrySchema, clinicalCustomerDraftSelectsSchema, draftSelectInterval, hasOverlappingClinicalDraftSelect, slotInterval };
//# sourceMappingURL=clinicalCustomerDraftSelects.mjs.map